// --------------------------------------------------------------
// Created On: 2025-06-23
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./QuoteListForm.module.scss";

// Form to filter the sales quotes list by name, quoteId, created and order dates.
export default function QuoteListForm(props: Props): Component {
  return (
    <div data-test="sales-quotes-table-header" className={`${styles.body} table-responsive mb-0 pb-0`}>
      <div className={styles.header}>
        <div className="row pt-3 pb-3 px-2">
          {/* Title. */}
          <div className="col-6">
            <span data-test="sales-quotes-table-title">Quotes ({props.rowCount})</span>
          </div>
        </div>
        <div className="row mb-2 mx-auto justify-content-around">
          <div className="col-6 col-sm-7 col-lg-9">
            <div className="input-group">
              <input
                data-test="sales-quotes-table-filter-input"
                type="search"
                className="form-control rounded"
                placeholder="Search all quotes..."
                value={props.filter}
                onChange={(e) => props.onChangeFilter(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3 col-sm-4 col-md-3">
            <select
              data-test="sales-quotes-date-filter-dropdown"
              className="form-select form-control"
              value={props.dateFilter}
              onChange={(e) => props.onChangeDateFilter(parseInt(e.target.value))}
            >
              <option value={30}>30 days</option>
              <option value={90}>3 months</option>
              <option value={365}>1 year</option>
              <option value={0}>All time</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  rowCount: number;
  filter: string;
  dateFilter: number;
  onChangeFilter: (filter: string) => void;
  onChangeDateFilter: (dateFilter: number) => void;
}
